/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CompactResponseRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  compactResponseRequest: components.CompactResponseRequest;
};

/** @internal */
export const CompactResponseRequest$inboundSchema: z.ZodType<
  CompactResponseRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CompactResponseRequest: components.CompactResponseRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CompactResponseRequest": "compactResponseRequest",
  });
});
/** @internal */
export type CompactResponseRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CompactResponseRequest: components.CompactResponseRequest$Outbound;
};

/** @internal */
export const CompactResponseRequest$outboundSchema: z.ZodType<
  CompactResponseRequest$Outbound,
  z.ZodTypeDef,
  CompactResponseRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  compactResponseRequest: components.CompactResponseRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    compactResponseRequest: "CompactResponseRequest",
  });
});

export function compactResponseRequestToJSON(
  compactResponseRequest: CompactResponseRequest,
): string {
  return JSON.stringify(
    CompactResponseRequest$outboundSchema.parse(compactResponseRequest),
  );
}
export function compactResponseRequestFromJSON(
  jsonString: string,
): SafeParseResult<CompactResponseRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompactResponseRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompactResponseRequest' from JSON`,
  );
}
